import { useContext, useCallback } from "react"
import { SpaceDashboardOutlined } from "@mui/icons-material"
import HomeHeader from "modules/home-header"
import InstrumentSelector from "connected-components/instrument-selector"
import { useAccountAlias, useIsAiTermsAccepted, useIsAiChatFeatureEnabled } from "resources/account"
import { useModelMetadata } from "resources/models"
import { usePositionSetMetadata } from "resources/position-sets"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"
import AiTeammateWithButtonToggle from "connected-components/ai-teammate/components/ai-toggle-button"
import { useAnalytics } from "connected-components/analytics"
import { DashboardContext } from "./context/dashboard"
import useOpenUnifiedSearch from "./hooks/use-open-unified-search"
import { DASHBOARD_EVENTS, InstrumentSelectionData } from "./analytics"
import { IDashboardContextValue } from "./context/types"
import { ResourceMenuSwitcher } from "./components/resource-menu"
import { useModelId } from "./hooks/use-model-id"

export default function DashboardHeader() {
  const accountAlias = useAccountAlias()
  const { instrument, setInstrument } = useContext<IDashboardContextValue>(DashboardContext)
  const modelId = useModelId()
  const analytics = useAnalytics()
  const isAiTermsAccepted = useIsAiTermsAccepted()
  const isAiChatFeatureEnabled = useIsAiChatFeatureEnabled()

  const [modelMetadata] = useModelMetadata(modelId ?? "")
  const [instrumentMetadata] = usePositionSetMetadata(modelId ?? "", instrument, modelMetadata?.availability?.currentDate)

  const canOpenAiDrawer = isAiTermsAccepted && isAiChatFeatureEnabled && !!instrument && !!modelId
  const onHeaderInstrumentSelection = useCallback(({ id, name, type, searchType, isInitialSelection }: InstrumentSelectionData) => {
    const payload = { instrument: { id, name, type }, searchType }
    if (isInitialSelection) {
      analytics.track(DASHBOARD_EVENTS.INITIAL_INSTRUMENT_SELECTION, payload)
    } else {
      analytics.track(DASHBOARD_EVENTS.COMPARISON_SEARCH_SELECTION, payload)
    }
  }, [analytics])

  const openSearch = useOpenUnifiedSearch(DashboardContext, setInstrument, RECENT_INSTRUMENT_SEARCH_TYPES.DASHBOARD, null, true, false, onHeaderInstrumentSelection)

  return <HomeHeader Icon={SpaceDashboardOutlined} title="Dashboard" account={accountAlias} className="dashboard-header" modelId={modelId}>
    <ResourceMenuSwitcher />
    {instrumentMetadata && <InstrumentSelector openSearch={openSearch} selectedInstrumentMetadata={instrumentMetadata} onClear={() => { setInstrument(null) }} size="medium" />}
    <div className="spacer" />
    {canOpenAiDrawer && <AiTeammateWithButtonToggle />}
  </HomeHeader>
}
